import Kr from './src/kr/kr';
import './src/app/components/MenuMobile';
import './src/app/components/HeaderFixed';
import './src/app/components/LayoutGallery';
import './src/app/components/Slider';
import './src/app/components/FrontGallery';
//import './src/app/components/LogotypesSlider';
import './src/app/components/SearchForm';
import './src/app/components/Mansory';
import './src/app/components/Availability';
import './src/app/components/AudioPlayer';

const app = new Kr.App;
app.run();
